'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { isEditableShortcutTarget } from '@/lib/utils';
import Mousetrap from 'mousetrap';
import { useEffect, useState } from 'react';
import {
  SECRET_CAT_ASCII,
  SECRET_CAT_EASTER_EGG_SEQUENCE,
  SECRET_CAT_MEOW,
} from './secret-cat-easter-egg';

export function SecretCatDialog() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handler = (e?: KeyboardEvent) => {
      if (e && isEditableShortcutTarget(e.target)) {
        return false;
      }

      e?.preventDefault();
      setIsOpen(true);
      return false;
    };

    Mousetrap.bind(SECRET_CAT_EASTER_EGG_SEQUENCE, handler);
    return () => {
      Mousetrap.unbind(SECRET_CAT_EASTER_EGG_SEQUENCE);
    };
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="overflow-hidden border-white/10 bg-zinc-950 p-0 shadow-2xl sm:max-w-md">
        <DialogHeader className="border-b border-white/10 px-5 py-4">
          <DialogTitle className="text-white">cat</DialogTitle>
          <DialogDescription>A tiny terminal cat appeared.</DialogDescription>
        </DialogHeader>
        <div className="bg-black px-5 py-6">
          <pre className="overflow-x-auto font-mono text-sm leading-6 whitespace-pre text-emerald-300">
            {SECRET_CAT_ASCII}
          </pre>
          <p className="mt-4 font-mono text-sm text-emerald-200">
            {SECRET_CAT_MEOW}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
